import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from "@angular/core";
import * as _ from "lodash";
import {
  CdkDrag,
  CdkDragDrop,
  CdkDragEnter,
  CdkDropList,
  moveItemInArray,
  transferArrayItem
} from "@angular/cdk/drag-drop";
import {PlanningDragAndDropService} from "../../services/planning-drag-and-drop.service";
import {PlanningPanelModel} from "../../../models/planning-panel.model";
import {PlanningViewSettingsModel} from "../../../models/planning-view-settings.model";
import {PanelService} from "../../../../commons/angular/services/panel.service";
import {EXPORT_EXCEL_SIZE_LIMIT} from "../../../../commons/angular/constants/commons";

require('./planning-draft-route-panel-view-test.scss');
@Component({
  standalone: false,
  selector: 'app-planning-draft-route-panel-view-test',
  templateUrl: './planning-draft-route-panel-view-test.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PlanningDraftRoutePanelViewTestComponent implements OnInit, OnChanges {

  @Input() index: any;
  @Input() panel: PlanningPanelModel;
  @Input() route: any;
  @Input() jobs: any[];
  @Input() panels: PlanningPanelModel[];
  @Input() routes: any;
  @Input() resources: any;
  @Input() settings: PlanningViewSettingsModel;
  @Input() visibleIds: string[];
  @Input() selectedJobIds: string[];
  @Input() selectedJobs: any[];
  @Input() highlightedActivity?: any;
  @Input() isLoading: boolean;
  @Input() itemElementSize: string;
  @Input() isDisplayRetrips: boolean;
  @Input() isValidateRouteVehicles: boolean;
  @Input() isAllowDraggingIntoDispatchedRoute: boolean;
  @Input() queryText: string;
  @Output() onSelect = new EventEmitter();
  @Output() onSelectJobs = new EventEmitter<string[]>();
  @Output() onViewJob = new EventEmitter<{ jobs: any[], event?: any }>();
  @Output() onVisibleRoutesChange = new EventEmitter<string[]>();
  @Output() onLockRouteChange = new EventEmitter<{ id: string, locked: boolean }>();
  @Output() onMoveActivity = new EventEmitter();
  @Output() onAddStopsToRoute = new EventEmitter();
  @Output() onDispatch = new EventEmitter<string>();
  @Output() onReoptimize = new EventEmitter<string>();
  @Output() onPrint = new EventEmitter<string>();
  @Output() onPrintLoadingSheet = new EventEmitter<string>();
  @Output() onPreAssignAgent = new EventEmitter<string>();
  @Output() onDelete = new EventEmitter<string>();
  @Output() onChangeRouteResource = new EventEmitter<{ routeId: string, event: any }>();
  @Output() onToggleObligateTimeWindow = new EventEmitter<{ jobIds: string[], obligateTimeWindow: boolean }>();
  @Output() onToggleLockJobs = new EventEmitter<{ jobIds: string[], isLocked: boolean }>();
  @Output() onEditResourceAllocation = new EventEmitter<{route: any, event: any}>();
  @Output() onFeedback = new EventEmitter<{ routeId: string, feedback: string }>();

  public jobsMap: any;
  public activityJobsMap: any;
  public connectedPanelIds: string[];
  private allowedDropIndexes: Set<number>;
  public selectedKeys: Object = {};
  public visibleKeys: Object;
  public tripTotalsMap: Object;
  public routeColor: string;
  public isSmallScreen: boolean;
  public isRunning: boolean = false;
  public logisticsVehicleName: string;

  constructor(
    @Inject(ElementRef) private elementRef,
    @Inject('planningCommonService') private planningCommonService,
    @Inject('$timeout') private $timeout,
    @Inject('planningAlertsService') private planningAlertsService,
    @Inject('planningDialogService') private planningDialogService,
    @Inject('confirmDialogService') private confirmDialogService,
    @Inject(PanelService) private panelService: PanelService,
    @Inject(PlanningDragAndDropService) private planningDragAndDropService: PlanningDragAndDropService) {
  }

  ngOnInit() {
    this._initActivitiesJobsMap();
    this.setRouteColor();
    this.sortPredicate = this.sortPredicate.bind(this);
    this.isSmallScreen = window.innerWidth < 1366;
    // this.initLockedActivities();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.selectedJobIds) {
      this.selectedKeys = {};

      this.selectedJobIds?.forEach((id) => {
        const activities = this.route.activities.filter((a) => {
          return a.jobIds ? _.includes(a.jobIds, id) : (a.jobId === id);
        })

        activities.forEach((a) => {
          this.selectedKeys[a.id] = true;
        })
      })
    }
    if (changes.route || changes.resources) {
      this.logisticsVehicleName = _.get(_.find(this.resources, {id: this.route?.resourceId}), 'mainLogisticsVehicleReference.name');
    }
    if (changes.route) {
      this._setTrips();
      this._initActivitiesJobsMap();
      this.setRouteColor();
      this._setIsRouteProcessRunning();

      const currentRoute = changes.route.currentValue,
        previousRoute = changes.route.previousValue;

      if (currentRoute?.id !== previousRoute?.id) {
        const el = this.elementRef.nativeElement.querySelector('.dndList');
        if (el) {
          (el as HTMLElement).scrollTo({top: 0, behavior: 'smooth'})
        }
      }
    }

    if (changes.panels || changes.panel || changes.route || changes.routes || changes.resources) {
      const filteredPanels = _.filter(this.panels, (p) => {
        return p.selectedRouteId ? (this.route.id !== p.selectedRouteId) : true;
      })
      this.connectedPanelIds = _.concat(_.map(filteredPanels, 'id'), _.map(this.routes, 'id'), _.map(this.resources, 'id'));
    }
    if (changes.visibleIds) {
      this.visibleKeys = {};
      _.forEach(this.visibleIds, (id) => {
        this.visibleKeys[id] = true;
      });
    }

    if (changes.queryText) {
      setTimeout(() => this.scrollToFirstHighlight(), 0);
    }

    if (changes.jobs && !changes.jobs.isFirstChange()) {
      this._initActivitiesJobsMap();
    }
  }

  scrollToFirstHighlight(): void {
    const el = this.elementRef.nativeElement.querySelector('.highlight');
    // const el = document.querySelector('.highlight');
    if (el) {
      (el as HTMLElement).scrollIntoView({behavior: 'smooth', block: 'center'});
    }
  }

  isActivityLocked(activity) {
    if (activity?.jobId) {
      return !!this.jobsMap[activity.jobId]?.lockedRouteId;
    } else if (activity?.jobIds?.length) {
      for (let id of activity.jobIds) {
        if (!!this.jobsMap[id]?.lockedRouteId) {
          return true;
        }
      }
      return false;
    }
  }

  onSelectedChange(activity: any, isSelected: boolean) {
    let selectedIds;
    let jobIds = activity.jobIds ? activity.jobIds : [activity.jobId];

    if (isSelected) {
      selectedIds = _.uniq([...this.selectedJobIds].concat(jobIds));
    } else {
      selectedIds = this.selectedJobIds.filter(id => !jobIds.includes(id));
    }

    this.onSelectJobs.emit(_.compact(selectedIds));
  }

  isMultipleActivitiesDragged(jobIds) {
    return this.selectedJobIds.length > 1 && !!_.intersection(this.selectedJobIds, jobIds).length;
  }

  // drop(event: CdkDragDrop<string[]>) {
  //   if (event.previousContainer === event.container) {
  //     moveItemInArray(this.route.activities, event.previousIndex, event.currentIndex);
  //   } else {
  //     transferArrayItem(
  //       event.previousContainer.data,
  //       event.container.data,
  //       event.previousIndex,
  //       event.currentIndex,
  //     );
  //   }
  // }

  onToggleVisibleRoute(id, isVisible: boolean) {
    this.visibleKeys[id] = isVisible;
    const visibleIds = _.map(this.visibleKeys, (value, key) => {
      if (value) return key;
    });

    this.onVisibleRoutesChange.emit(_.compact(visibleIds));
  }

  sortPredicate(index: number, item: CdkDrag<any>, drop: CdkDropList) {

    const startIndex = _.findIndex(drop.data, (a: any) => {
      return a.type === 'START';
    })
    const endIndex = _.findIndex(drop.data, (a: any) => {
      return a.type === 'END';
    })

    if (((startIndex > -1) && (startIndex >= index)) || ((endIndex > -1) && endIndex < index)) {
      return false;
    }

    // Add Job To Route
    if (item.data.jobType) {
      return true;
      // const canAdd = this._canJobAddToRoute(item.data, this.route);
      //
      // return canAdd;

      // if (!canAdd) {
      //
      // }

    }
    // Add Activity To Route
    else {
      const itemType = item.data.type;
      const stopType = item.data.stopType;

      // Drop to same route type
      const isOperationList = _.find(drop.data, (a: any) => {
        return a.stopType === 'Operation';
      })
      if (!!isOperationList && stopType !== 'Operation') {
        return false;
      }

      if (stopType === 'Operation') {
        return true;
      }


      return this.planningDragAndDropService.canReorderRouteActivity(index, item, drop, this.selectedJobIds);
    }

  }

  enter(event: CdkDragEnter) {

  }

  drop(event: CdkDragDrop<string[]>) {
    this.planningDragAndDropService.onDropRouteActivities(
      event,
      this.selectedJobIds,
      this.jobsMap,
      this.route,
      this.isValidateRouteVehicles,
      this.isAllowDraggingIntoDispatchedRoute,
      this.jobs
    ).then((payload) => {
      if (payload) {
        this.onMoveActivity.emit(payload);
      }
    });
  }

  private setRouteColor() {
    this.routeColor = this.planningCommonService.getRouteColor(this.route);
  }

  private _setTrips() {
    this.tripTotalsMap = {};

    this.route.activities.forEach((a, index) => {
      if (!!a.tripNumber) {
        if (!this.tripTotalsMap[a.tripNumber]) {
          this.tripTotalsMap[a.tripNumber] = {
            firstActivityId: a.id,
            tripNumber: a.tripNumber,
            packages: [],
            Pickup: 0,
            Dropoff: 0,
            Operation: 0,
            isExpanded: true
          };
        }

        if (a.stopType === 'Dropoff' || a.stopType === 'Operation') {
          this.tripTotalsMap[a.tripNumber].packages = this.tripTotalsMap[a.tripNumber].packages.concat(a.packages || []);
        }
        this.tripTotalsMap[a.tripNumber][a.stopType] = this.tripTotalsMap[a.tripNumber][a.stopType] + 1;
        // this.tripTotalsMap[a.tripNumber].stopsCount = a.jobIds?.length ? this.tripTotalsMap[a.tripNumber].stopsCount + a.jobIds.length : this.tripTotalsMap[a.tripNumber].stopsCount + 1;
      }
    })
  }

  private _initActivitiesJobsMap() {
    this.jobsMap = _.keyBy(this.jobs, (j) => {
      return j.id
    })

    this.activityJobsMap = {};

    this.route.activities.forEach((a) => {
      this.activityJobsMap[a.id] = [];

      if (a.jobId) {
        this.activityJobsMap[a.id].push(this.jobsMap[a.jobId]);
      }

      if (a.jobIds?.length) {
        const jobs = [];
        a.jobIds.forEach(jobId => {
          jobs.push(this.jobsMap[jobId]);
        })
        this.activityJobsMap[a.id] = this.activityJobsMap[a.id].concat(jobs);
      }

      this.activityJobsMap[a.id] = _.compact(this.activityJobsMap[a.id]);
    });
  }

  private _setIsRouteProcessRunning() {
    this.isRunning = this.route.actionProcess?.running && (new Date().getTime() < this.route.actionProcess?.expirationDate);
  }
}
